import { render, staticRenderFns } from "./PayFor.vue?vue&type=template&id=46dd0cdf&scoped=true&"
import script from "./PayFor.vue?vue&type=script&lang=js&"
export * from "./PayFor.vue?vue&type=script&lang=js&"
import style0 from "./PayFor.vue?vue&type=style&index=0&id=46dd0cdf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dd0cdf",
  null
  
)

export default component.exports